import * as React from 'react';
import MenuItem from './MenuItem';
import { MenuItemContent, menuItems } from './menuItems';
import { observer } from 'mobx-react';
import { currentUserStore } from '../../../../CurrentUserStore';
import SupportLink from './SupportLink';
import { sort } from '@execonline-inc/collections';

const sortMenuItemsByContent = (a: MenuItemContent, b: MenuItemContent) =>
  a.content.localeCompare(b.content);

const Menu: React.FC = () => {
  return (
    <div className="block list-none p-0 m-0 lg:flex items-center flex-1">
      {sort(sortMenuItemsByContent, menuItems(currentUserStore.links)).map(
        (mi: MenuItemContent) => (
          <MenuItem key={mi.rel} menuItemContent={mi} />
        ),
      )}
      <SupportLink />
    </div>
  );
};

export default observer(Menu);
